import { TechRadarComponent } from '@backstage-community/plugin-tech-radar'
import { Content, ContentHeader, Header, Page } from '@backstage/core-components'
import { Link, Typography } from '@material-ui/core'
import Input from '@material-ui/core/Input'
import { useState } from 'react'

export function AITechRadarPage() {
  const [searchText, setSearchText] = useState('')
  return (
    <Page themeId="tool">
      <Header title="AI Technology Radar" subtitle="Our AI technology choices" />
      <Content>
        <ContentHeader title="AI Radar">
          <Input
            id="ai-tech-radar-filter"
            type="search"
            placeholder="Filter"
            onChange={e => setSearchText(e.target.value)}
          />
        </ContentHeader>
        <Typography variant="body1" paragraph>
          This radar shows our current assessment of AI technologies.
        </Typography>
        <Typography variant="body1" paragraph style={{ marginBottom: '2rem' }}>
          New topics are first collected and assessed in the{' '}
          <strong>
            <Link
              href="https://sennder.atlassian.net/wiki/spaces/AE/pages/5024907276/AI+Tech+Evaluation+and+Backlog"
              target="_blank"
              rel="noopener noreferrer"
            >
              AI Tech Evaluation and Backlog Confluence page
            </Link>
          </strong>
          , where the team tracks interesting candidates, and ongoing discussions and
          evaluation results before the technologies graduate onto this radar.
        </Typography>
        <TechRadarComponent id="ai" width={1500} height={800} searchText={searchText} />
      </Content>
    </Page>
  )
}
